import { render } from "./PublicMap.vue?vue&type=template&id=4b0af396"
import script from "./PublicMap.vue?vue&type=script&lang=js"
export * from "./PublicMap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__